import { dayjs } from "@thalamos/common";
import type {
  OrganisationMembership,
  TeamMembership,
} from "@thalamos/aspire-common";

export function ukLocalFormatDate(utcValue: string) {
  return dayjs.utc(utcValue).tz("Europe/London").format("DD/MM/YYYY");
}

export function ukLocalFormatTime(utcValue: string) {
  return dayjs.utc(utcValue).tz("Europe/London").format("HH:mm");
}

export function ukLocalFormatDateTime(utcValue: string) {
  return dayjs.utc(utcValue).tz("Europe/London").format("DD-MM-YYYY HH:mm");
}

export function formatInterviewTimeRange(
  startIso: string,
  endIso: string,
): string {
  const start = dayjs(startIso).tz("Europe/London");
  const end = dayjs(endIso).tz("Europe/London");
  const startLabel = start.format("ddd D MMM YYYY, HH:mm");
  const endLabel = start.isSame(end, "day")
    ? end.format("HH:mm")
    : end.format("ddd D MMM YYYY, HH:mm");
  return `${startLabel} – ${endLabel}`;
}

function roleUnknown(_role: never): string {
  throw Error(`Unknown role`);
}

export function getRoleLabel(
  role: OrganisationMembership["role"] | TeamMembership["role"],
): string {
  switch (role) {
    case "manager":
      return "Admin";
    case "member":
      return "Member";
    case "demographics-manager":
      return "Demographics Admin";
    case "analytics-viewer":
      return "Analytics Viewer";
    default:
      return roleUnknown(role);
  }
}
